import { useValidateUserHasRbacPermissions as originalUseValidateUserHasRbacPermissions } from '@sironamedical/common/hooks/useValidateUserHasRbacPermissions';
import { useGetUserPermissions } from './useGetUserPermissions';

/** Wraps around useGetUserHasPermissions and provides permissions to avoid boilerplate  */
export const useValidateUserHasRbacPermissions = ({
  permissionNames,
  scopeId,
}: Omit<
  Parameters<typeof originalUseValidateUserHasRbacPermissions>[0],
  'permissions'
>): boolean => {
  const permissions = useGetUserPermissions();

  return originalUseValidateUserHasRbacPermissions({
    permissions,
    permissionNames,
    scopeId,
  });
};
